module.exports = __webpack_public_path__ + "img/satisfaction.18abe242.png";